import { render, staticRenderFns } from "./OrderablePreviewItemNote.vue?vue&type=template&id=060af717&"
import script from "./OrderablePreviewItemNote.vue?vue&type=script&lang=ts&"
export * from "./OrderablePreviewItemNote.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports